<ion-card>
  <ion-grid>
    <ion-row>
      <mat-horizontal-stepper linear #stepper>
        <mat-step [stepControl]="eCheckForm">
          <form [formGroup]="eCheckForm">
            <ng-template matStepLabel>Account Information</ng-template>
            <ion-grid>
              <ion-row>
                <ion-col>
                  <mat-form-field appearance="outline">
                    <mat-label>Amount</mat-label>
                    <input
                      matInput
                      required
                      type="number"
                      name="amount"
                      formControlName="amount"
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      eCheckForm.controls.amount.touched &&
                      !eCheckForm.controls.amount.valid
                    "
                    class="ec-error"
                  >
                    <div *ngIf="eCheckForm.controls.amount.errors?.required">
                      Amount is required
                    </div>
                    <div *ngIf="eCheckForm.controls.amount.errors?.min">
                      Minimum payment is $1.00
                    </div>
                    <div *ngIf="eCheckForm.controls.amount.errors?.max">
                      Maximum payment is {{ amountDue }}
                    </div>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <mat-form-field class="full" appearance="outline">
                    <mat-label>Name as it appears on the account</mat-label>
                    <input
                      matInput
                      required
                      namePattern
                      type="text"
                      name="name"
                      formControlName="name"
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      eCheckForm.controls.name.touched &&
                      !eCheckForm.controls.name.valid
                    "
                    class="ec-error"
                  >
                    <div *ngIf="eCheckForm.controls.name.errors?.required">
                      Name is required
                    </div>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <mat-form-field class="full" appearance="outline">
                    <mat-label>Routing Number</mat-label>
                    <input
                      matInput
                      required
                      numberOnly
                      type="text"
                      name="routingNumber"
                      minlength="9"
                      maxlength="9"
                      formControlName="routingNumber"
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      eCheckForm.controls.routingNumber.touched &&
                      !eCheckForm.controls.routingNumber.valid
                    "
                    class="ec-error"
                  >
                    <div
                      *ngIf="eCheckForm.controls.routingNumber.errors?.required"
                    >
                      Routing Number is required
                    </div>
                    <div
                      *ngIf="
                        eCheckForm.controls.routingNumber.errors?.minlength
                      "
                    >
                      Routing Number must be 9 digits
                    </div>
                  </div>
                </ion-col>
                <ion-col>
                  <mat-form-field class="full" appearance="outline">
                    <mat-label>Account Number</mat-label>
                    <input
                      matInput
                      required
                      type="text"
                      name="accountNumber"
                      formControlName="accountNumber"
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      eCheckForm.controls.accountNumber.touched &&
                      !eCheckForm.controls.accountNumber.valid
                    "
                    class="ec-error"
                  >
                    <div
                      *ngIf="eCheckForm.controls.accountNumber.errors?.required"
                    >
                      Account Number is required
                    </div>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
            <div>
              <button
                id="btn-next"
                class="step-button"
                [disabled]="!eCheckForm.valid"
                mat-button
                matStepperNext
              >
                Next
              </button>
            </div>
          </form>
        </mat-step>
        <mat-step [stepControl]="billingAddressForm">
          <form [formGroup]="billingAddressForm">
            <ng-template matStepLabel>Billing Address</ng-template>
            <ion-grid>
              <ion-row>
                <ion-col>
                  <mat-form-field class="full" appearance="outline">
                    <mat-label>Street</mat-label>
                    <input
                      matInput
                      required
                      type="text"
                      name="street"
                      formControlName="street"
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      billingAddressForm.controls.street.touched &&
                      !billingAddressForm.controls.street.valid
                    "
                    class="ec-error"
                  >
                    <div
                      *ngIf="
                        billingAddressForm.controls.street.errors?.required
                      "
                    >
                      Street is required
                    </div>
                  </div>
                </ion-col>
                <ion-col>
                  <mat-form-field class="full" appearance="outline">
                    <mat-label>Street Line 2</mat-label>
                    <input
                      matInput
                      type="text"
                      name="line2"
                      formControlName="line2"
                    />
                  </mat-form-field>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <mat-form-field class="full" appearance="outline">
                    <mat-label>Zip Code</mat-label>
                    <input
                      matInput
                      required
                      zipCode
                      type="text"
                      name="zip"
                      formControlName="zip"
                      (keyup)="onZipChange()"
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      billingAddressForm.controls.zip.touched &&
                      !billingAddressForm.controls.zip.valid
                    "
                    class="ec-error"
                  >
                    <div
                      *ngIf="billingAddressForm.controls.zip.errors?.required"
                    >
                      Zip Code is required
                    </div>
                    <div
                      *ngIf="billingAddressForm.controls.zip.errors?.pattern"
                    >
                      Zip Code is invalid
                    </div>
                  </div>
                </ion-col>
                <ion-col>
                  <mat-form-field class="full" appearance="outline">
                    <mat-label>City</mat-label>
                    <input
                      matInput
                      required
                      type="text"
                      name="city"
                      formControlName="city"
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      billingAddressForm.controls.city.touched &&
                      !billingAddressForm.controls.city.valid
                    "
                    class="ec-error"
                  >
                    <div
                      *ngIf="billingAddressForm.controls.city.errors?.required"
                    >
                      City is required
                    </div>
                  </div>
                </ion-col>
                <ion-col>
                  <mat-form-field class="full" appearance="outline">
                    <mat-label>State</mat-label>
                    <mat-select required formControlName="state">
                      <mat-option *ngFor="let state of states" [value]="state">
                        {{ state }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div
                    *ngIf="
                      billingAddressForm.controls.state.touched &&
                      !billingAddressForm.controls.state.valid
                    "
                    class="ec-error"
                  >
                    <div
                      *ngIf="billingAddressForm.controls.state.errors?.required"
                    >
                      State is required
                    </div>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
            <div>
              <button
                id="btn-prev"
                class="step-button"
                mat-button
                matStepperPrevious
              >
                Back
              </button>
            </div>
          </form>
        </mat-step>
      </mat-horizontal-stepper></ion-row
    >
    <div>
      <ion-row class="ion-align-items-center ion-justify-content-center">
        <ion-button
          shape="round"
          expand="block"
          class="button-red"
          [disabled]="!eCheckForm.valid || !billingAddressForm.valid"
          (click)="onSubmitPayment()"
        >
          Submit Payment
        </ion-button>
      </ion-row>
    </div>
  </ion-grid>
</ion-card>
